import { useState, useContext, useEffect, forwardRef, useImperativeHandle, useRef } from "react";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";

import SuiInput from "components/SuiInput";
import SuiButton from "components/SuiButton";
import SuiTypography from "components/SuiTypography";
import SuiBox from "components/SuiBox";
import SuiBadge from "components/SuiBadge";

import Checkbox from "@mui/material/Checkbox";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Tooltip from "@mui/material/Tooltip";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import Basket from "examples/Icons/Basket";
import Office from "examples/Icons/Office";
import CustomerSupport from "examples/Icons/CustomerSupport";
import Shop from "examples/Icons/Shop";

import api from "services/api";
import { Tag } from "antd";
import { roleTags } from "utils/data";

const { CheckableTag } = Tag;

const SelectRoleCard = forwardRef(
  ({ accountRole, setAccountRole, accountTags, setAccountTags, isReferMode, ...rest }, ref) => {
    const [open, setOpen] = useState(false);
    const [inputTag, setInputTag] = useState();

    const customButtonStyles = ({
      functions: { pxToRem, rgba },
      borders: { borderWidth },
      palette: { transparent, dark, secondary },
    }) => ({
      width: pxToRem(80),
      height: pxToRem(48),
      borderWidth: borderWidth[2],
      mb: 0.5,
      ml: 0.5,

      "&.MuiButton-contained, &.MuiButton-contained:hover": {
        boxShadow: "none",
        border: `${borderWidth[2]} solid ${transparent.main}`,
      },
    });

    const handleChange = (tag) => {
      setAccountTags((pr) => (pr.includes(tag) ? pr.filter((t) => t !== tag) : [...pr, tag]));
    };

    const handleChangeRole = (role) => {
      // if (!isReferMode) {
      setAccountRole(role);
      //}
    };

    const handleAddOtherTag = () => {
      let newTag = inputTag || "";
      newTag = newTag.trim();

      console.log(newTag);
      if (newTag) {
        if (!roleTags.includes(newTag)) {
          roleTags.push(newTag);
        }
        setInputTag("");
        handleChange(newTag);
        handleClose();
      }
    };
    const handleClickOpen = () => {
      setOpen(true);
    };

    const handleClose = () => {
      setOpen(false);
    };

    return (
      <SuiBox {...rest}>
        <SuiTypography variant="h6" fontWeight="bold">
          Choose your role
        </SuiTypography>
        <Grid container spacing={1} px={1} justifyContent="center" sx={{ mt: 1 }}>
          <Grid item xs={6} sm={3} md={3}>
            <SuiBox textAlign="center">
              <SuiButton
                color="secondary"
                readOnly
                variant={accountRole == "de" ? "contained" : "outlined"}
                sx={customButtonStyles}
                onClick={() => handleChangeRole("de")}
              >
                <Basket size="24px" color={accountRole == "de" ? "white" : "dark"} />
              </SuiButton>
              <SuiTypography variant="body1" fontWeight="bold">
                Designer
              </SuiTypography>
            </SuiBox>
          </Grid>

          <>
            <Grid item xs={6} sm={3} md={3}>
              <SuiBox textAlign="center">
                <SuiButton
                  readOnly
                  color="secondary"
                  variant={accountRole == "ma" ? "contained" : "outlined"}
                  sx={customButtonStyles}
                  onClick={() => handleChangeRole("ma")}
                >
                  <Office size="24px" color={accountRole == "ma" ? "white" : "dark"} />
                </SuiButton>
                <SuiTypography variant="body1" fontWeight="bold">
                  Manufacturer
                </SuiTypography>
              </SuiBox>
            </Grid>
            <Grid item xs={6} sm={3} md={3}>
              <SuiBox textAlign="center">
                <SuiButton
                  readOnly
                  color="secondary"
                  variant={accountRole == "bu" ? "contained" : "outlined"}
                  sx={customButtonStyles}
                  onClick={() => handleChangeRole("bu")}
                >
                  <Shop size="24px" color={accountRole == "bu" ? "white" : "dark"} />
                </SuiButton>
                <SuiTypography variant="body1" fontWeight="bold">
                  Buyer
                </SuiTypography>
              </SuiBox>
            </Grid>
            <Grid item xs={6} sm={3} md={3}>
              <SuiBox textAlign="center">
                <SuiButton
                  readOnly
                  color="secondary"
                  variant={accountRole == "sp" ? "contained" : "outlined"}
                  sx={customButtonStyles}
                  onClick={() => handleChangeRole("sp")}
                >
                  <CustomerSupport size="24px" color={accountRole == "sp" ? "white" : "dark"} />
                </SuiButton>
                <SuiTypography variant="body1" fontWeight="bold">
                  Specialist
                </SuiTypography>
              </SuiBox>
            </Grid>
          </>
        </Grid>
        {accountRole == "sp" ? (
          <SuiBox sx={{ maxWidth: 500, mt: 2 }}>
            <SuiTypography variant="h6" fontWeight="bold">
              Choose your tags
            </SuiTypography>
            {roleTags.map((rt) => (
              <SuiBadge
                color={accountTags.includes(rt) ? "dark" : "light"}
                variant="contained"
                size="xs"
                badgeContent={
                  <div
                    style={{
                      fontSize: "13px",
                      textTransform: "capitalize",
                      cursor: "pointer",
                    }}
                  >
                    {rt}
                  </div>
                }
                sx={{ borderRadius: "none", mb: 0.5 }}
                onClick={() => handleChange(rt)}
              />
            ))}
            <SuiBadge
              color={"light"}
              variant="contained"
              size="xs"
              badgeContent={
                <div
                  style={{
                    fontSize: "13px",
                    textTransform: "capitalize",
                    cursor: "pointer",
                  }}
                >
                  Other
                </div>
              }
              sx={{ borderRadius: "none", mb: 0.5 }}
              onClick={handleClickOpen}
            />
          </SuiBox>
        ) : null}
        {open ? (
          <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xs">
            <DialogTitle>Add Tag</DialogTitle>
            <DialogContent>
              <SuiBox display="flex" flexDirection="column" justifyContent="flex-end" height="100%">
                <SuiBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                  <SuiTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                    textTransform="capitalize"
                    required
                  >
                    Customized Tag
                  </SuiTypography>
                </SuiBox>
                <SuiInput
                  placeholder="New Tag"
                  value={inputTag}
                  onChange={(e) => setInputTag(e?.target?.value)}
                  required
                />
              </SuiBox>
            </DialogContent>
            <DialogActions>
              <SuiButton variant="text" color="secondary" onClick={handleClose}>
                Cancel
              </SuiButton>
              <SuiButton variant="contained" color="dark" onClick={handleAddOtherTag}>
                Add
              </SuiButton>
            </DialogActions>
          </Dialog>
        ) : null}
      </SuiBox>
    );
  }
);

export default SelectRoleCard;
